export const EVENTS_SAMPLING_RATE = {
  INIT: 5,
  SDK_LOAD_TIME_EVENT: 5,
  MERCHANT_WARN: 5,
  ENTRY: 5,
}

export const getSampleGroup = (sampleRate: number) => {
  // eslint-disable-next-line security-node/detect-insecure-randomness
  return Math.random() * 100 < sampleRate
}
